// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9acbbdfc","453":"bc10ff71","455":"6037b6e0"}[chunkId] + ".chunk.js";
};